var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMalaysia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_my_flag"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 24,
    rx: 3,
    ry: 3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_my_flag)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 24,
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 2.2142857142857144,
    width: 25,
    height: 1.7142857142857142,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 5.642857142857142,
    width: 25,
    height: 1.7142857142857142,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 9.071428571428571,
    width: 25,
    height: 1.7142857142857142,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12.5,
    width: 25,
    height: 1.7142857142857142,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 15.928571428571427,
    width: 25,
    height: 1.7142857142857142,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 19.357142857142858,
    width: 25,
    height: 1.7142857142857142,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 22.785714285714285,
    width: 25,
    height: 1.7142857142857142,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 12.5,
    height: 12,
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.75,
    cy: 6.5,
    r: 3.96,
    fill: "#FFD100"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.413,
    cy: 6.5,
    r: 3.089,
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.750,3.411 10.046,5.205 11.090,3.717 10.578,5.462 12.165,4.574 10.947,5.924 12.761,5.813 11.078,6.500 12.761,7.187 10.947,7.076 12.165,8.426 10.578,7.538 11.090,9.283 10.046,7.795 9.750,9.589 9.454,7.795 8.410,9.283 8.922,7.538 7.335,8.426 8.553,7.076 6.739,7.187 8.422,6.500 6.739,5.813 8.553,5.924 7.335,4.574 8.922,5.462 8.410,3.717 9.454,5.205",
    fill: "#FFD100"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysia);
export default __webpack_public_path__ + "static/media/malaysia.44b53e38e8c391694eb3f88b141078be.svg";
export { ForwardRef as ReactComponent };